module.exports = __webpack_public_path__ + "img/cloth_g1_hat_13.ca76986a.svg";